import {
    PublicClientApplication,
    InteractionRequiredAuthError,
} from "@azure/msal-browser";
import { config } from "../../config/config";

const TENANT_ID = "4b1c6b54-4031-481e-b9c8-9000b4e3b2c2";
const SCOPES = [`api://${config.CLIENT_ID}/.default`];

const msalInstance = new PublicClientApplication({
    auth: {
        clientId: config.CLIENT_ID,
        authority: `https://login.microsoftonline.com/${TENANT_ID}`,
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
});

let _initPromise: Promise<void> | null = null;

function init(): Promise<void> {
    if (!_initPromise) {
        _initPromise = msalInstance.initialize();
    }
    return _initPromise;
}

export async function getAccessToken(): Promise<string> {
    await init();

    const accounts = msalInstance.getAllAccounts();

    if (accounts.length > 0) {
        try {
            const result = await msalInstance.acquireTokenSilent({
                scopes: SCOPES,
                account: accounts[0],
            });
            return result.accessToken;
        } catch (e) {
            if (!(e instanceof InteractionRequiredAuthError)) throw e;
        }
    }

    const result = await msalInstance.loginPopup({ scopes: SCOPES });
    return result.accessToken;
}
